import React from 'react';
import cx from 'classnames';

import Button from 'app/components/ui/Button';
import BookmarkSvg from 'app/components/common/Bookmark';
import { QUIPUSWAP, QUIPUSWAP_LIQUIDITY } from 'app/utils/defaults';
import TokenImage from 'app/components/ui/TokenImage';
import EquivalentPairInfo from 'app/components/ui/EquivalentPairInfo';
import { PairsType } from 'app/types/head-section';
import { getSlice } from 'app/utils/helpers';

import s from './PairHeadSection.module.sass';

import Version from '../Version';

type PairHeadSectionProps = {
  pair: PairsType
  loading?: boolean
  id: string
};

const PairHeadSection: React.FC<PairHeadSectionProps> = ({
  pair,
  loading,
  id,
}) => {
  const tokenId: string = `${pair.token2Standard === 'FA2' ? `_${pair.token2TokenId}` : ''}`;

  return (
    <section className={cx(s.root)}>
      <div className={cx(s.header)}>
        <div className={cx(s.tokenInfoWrapper)}>
          <TokenImage
            firstTokenImage={pair.token1Image}
            secondTokenImage={pair.token2Image}
            className={cx(s.token)}
            sizeT="large"
            tokensNames={{
              firstTokenName: pair.token1Name,
              secondTokenName: pair.token2Name,
            }}
          />

          <h1 className={cx(s.title)}>
            {loading ? '...' : `${pair.token1Name} / ${getSlice(pair.token2Name)}`}
          </h1>

          <Version version={pair.version} className={cx(s.version)} />

          <BookmarkSvg id={id} field="pairs" className={cx(s.bookmark, s.mobile)} />
        </div>

        <div className={cx(s.buttonsWrapper)}>
          <Button sizeT="medium" href={`${QUIPUSWAP_LIQUIDITY}${pair.token2Id}${tokenId}`} className={cx(s.button)}>
            + Add liquidity
          </Button>

          <Button
            sizeT="medium"
            href={`${QUIPUSWAP}?from=${pair.token1Id.toLowerCase()}&to=${pair.token2Id}${tokenId}`}
            className={cx(s.button, s.mobile)}
          >
            Trade
          </Button>

          <Button
            sizeT="small"
            href={`${QUIPUSWAP}?from=${pair.token1Id.toLowerCase()}&to=${pair.token2Id}${tokenId}`}
            className={cx(s.button, s.desktop)}
          >
            Trade
          </Button>

          <BookmarkSvg id={id} field="pairs" className={cx(s.desktop)} />
        </div>
      </div>

      <div className={cx(s.wrapper)}>
        <EquivalentPairInfo
          id={pair.token2Id}
          image={pair.token2Image}
          name={getSlice(pair.token2Name)}
          tokenId={pair.token2TokenId}
          equivalentTokenValue={pair.token1OneForOne}
          equivalentTokenName={pair.token1Name}
          price={pair.token2Price}
          className={cx(s.tokenInfo)}
          loading={loading}
        />

        <EquivalentPairInfo
          id={pair.token1Id}
          image={pair.token1Image}
          name={pair.token1Name}
          equivalentTokenValue={pair.token2OneForOne}
          equivalentTokenName={getSlice(pair.token2Name)}
          price={pair.token1Price}
          className={cx(s.tokenInfo)}
          loading={loading}
        />
      </div>
    </section>
  );
};

export default PairHeadSection;
